import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactIconButton from 'shared/design-system/components/TrueImpactIconButton';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { faPrint, faArrowLeft } from '@fortawesome/pro-light-svg-icons';

interface ReportHeaderProps {
  heading: string;
  handlePrint: () => unknown;
  isThirdParty: boolean;
  showBackButton?: boolean;
}

const StyledDiv = styled.div`
  background-color: ${COLORS.grayDarkest};
  padding: ${SPACERS.small} ${SPACERS.extraLarge};
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .report-header-heading {
    margin: 0;
    color: ${COLORS.whiteBase};
  }
  .report-header-left {
    display: flex;
    align-items: center;
    gap: ${SPACERS.small};
  }
`;

const ReportHeader: React.FC<ReportHeaderProps> = ({
  heading,
  handlePrint,
  showBackButton = false,
}) => {
  return (
    <StyledDiv className="impact-receipt-report-header">
      <div className="report-header-left">
        {showBackButton && (
          <TrueImpactIconButton
            label="Back"
            color="whiteBase"
            icon={faArrowLeft}
            onClick={() => window.history.back()}
          />
        )}
        <TrueImpactText
          variant="heading-label"
          className="report-header-heading"
        >
          {heading}
        </TrueImpactText>
      </div>
      <TrueImpactIconButton
        icon={faPrint}
        color="whiteBase"
        label="Print"
        onClick={handlePrint}
      />
    </StyledDiv>
  );
};

export default ReportHeader;
